"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DpIntervalPicker = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var DpIntervalPicker_styled_1 = require("./DpIntervalPicker.styled");
var api_1 = require("../../../api");
var react_i18next_1 = require("react-i18next");
var generateOptions = function (min, max, interval, handler, selectedValue) {
    var options = [];
    var intervalOption = min;
    var counter = 0;
    while (intervalOption <= max) {
        options.push((0, jsx_runtime_1.jsx)("li", { "data-value": intervalOption, onMouseDown: handler, onKeyDown: (0, api_1.handleButtonPress)(handler), "data-index": counter, tabIndex: -1, role: "option", "aria-selected": intervalOption.toString() === selectedValue, children: intervalOption }, intervalOption));
        intervalOption += interval;
        counter++;
    }
    return options;
};
var DpIntervalPicker = function (_a) {
    var min = _a.min, max = _a.max, interval = _a.interval, selectedInterval = _a.selectedInterval, selectionHandler = _a.selectionHandler, _b = _a.disabled, disabled = _b === void 0 ? false : _b, _c = _a.invalid, invalid = _c === void 0 ? false : _c;
    var ref = (0, react_1.useRef)();
    var _d = (0, react_1.useState)(selectedInterval || ''), value = _d[0], setValue = _d[1];
    var _e = (0, react_1.useState)(false), isMenuOpen = _e[0], setIsMenuOpen = _e[1];
    var _f = (0, react_1.useState)([]), options = _f[0], setOptions = _f[1];
    var _g = (0, api_1.useRoveFocus)(options.length, ref), focusIndex = _g[0], setFocusIndex = _g[1];
    var t = (0, react_i18next_1.useTranslation)('common').t;
    (0, react_1.useEffect)(function () {
        setValue(selectedInterval || '');
        var selectedValue;
        setOptions(generateOptions(min, max, interval, function (e) {
            var intervalValue = e.currentTarget.getAttribute('data-value');
            if (intervalValue) {
                setValue(intervalValue);
                selectedValue = intervalValue;
            }
            selectionHandler(intervalValue);
            setIsMenuOpen(false);
        }, selectedValue));
    }, [selectedInterval, min, max, interval, selectionHandler]);
    (0, react_1.useEffect)(function () {
        var _a;
        (_a = ref.current.querySelector("[data-index=\"".concat(focusIndex, "\"]"))) === null || _a === void 0 ? void 0 : _a.focus();
    }, [focusIndex]);
    (0, react_1.useEffect)(function () {
        var _a;
        (_a = ref.current.querySelector("[data-index='0']")) === null || _a === void 0 ? void 0 : _a.focus();
        if (isMenuOpen)
            setFocusIndex(0);
    }, [isMenuOpen, setFocusIndex]);
    var handleBlur = function () {
        selectionHandler(value);
    };
    var handleKeyUp = function (e) {
        if (e.key === 'Enter' || e.key === 'ArrowDown') {
            setIsMenuOpen(!isMenuOpen);
        }
    };
    var handleChange = function (e) { return setValue(e.target.value); };
    var handleClick = function () { return setIsMenuOpen(!isMenuOpen); };
    return ((0, jsx_runtime_1.jsxs)(DpIntervalPicker_styled_1.StyledIntervalPicker, { className: "dropdown-input", ismenuopen: isMenuOpen ? 1 : 0, invalid: invalid ? 1 : 0, children: [(0, jsx_runtime_1.jsx)("input", { value: value, onClick: handleClick, onChange: handleChange, onKeyUp: handleKeyUp, onBlur: handleBlur, disabled: disabled, "aria-label": t('DpIntervalPicker.ariaLabel', { time: value }) }), (0, jsx_runtime_1.jsx)("ul", { ref: ref, role: "listbox", "aria-expanded": !!isMenuOpen, "aria-label": t('DpIntervalPicker.ariaLabel', { time: value }), children: options })] }));
};
exports.DpIntervalPicker = DpIntervalPicker;
exports.default = exports.DpIntervalPicker;
